import React, { useState } from "react";
import { TextField } from "@mui/material";

const EquipmentFilterField = ({ headCol, handleFilterChange }) => {
  const [filterValue, setFilterValue] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setFilterValue(value);

    if (headCol.filter) {
      handleFilterChange(e.target, value, headCol.filter.field);
    }
  };

  return (
    <TextField
      id={headCol.name}
      label={headCol.name}
      variant="outlined"
      size="small"
      value={filterValue}
      onChange={handleChange}
    />
  );
};

export default EquipmentFilterField;
